import { Outlet } from 'react-router-dom';
import JobDocumentHeader from './JobDocumentHeader';

const JobDetailsListing = () => {

  return (
    <>
      <JobDocumentHeader />
      <Outlet />
    </>

  );
};

export default JobDetailsListing;
